/* tslint:disable */
/* eslint-disable */
/**
 * Payment App-Tier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentProviderCode = {
    AMWAY: 'AMWAY',
    P2C2P: '2C2P',
    MAGIC: 'MAGIC',
    KBANK: 'KBANK',
    OTHERS: 'OTHERS',
    CNB: 'CNB',
    MOCK_PROVIDER: 'MOCK_PROVIDER',
    PAYU: 'PAYU',
    OFFLINE_ADC: 'OFFLINE_ADC',
    IXOPAY: 'IXOPAY'
} as const;
export type PaymentProviderCode = typeof PaymentProviderCode[keyof typeof PaymentProviderCode];


export function PaymentProviderCodeFromJSON(json: any): PaymentProviderCode {
    return PaymentProviderCodeFromJSONTyped(json, false);
}

export function PaymentProviderCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentProviderCode {
    return json as PaymentProviderCode;
}

export function PaymentProviderCodeToJSON(value?: PaymentProviderCode | null): any {
    return value as any;
}

